import { ACTION_STATUS } from "../actionbar-detail.constant";
import { ButtonBase } from "./button.base";

export class ReceiptButtonModel extends ButtonBase {
    label: string = 'Receipt';
    action: string = ACTION_STATUS.receipt;
    matIconName: string = 'receipt_long';
    colorClass: string = 'color-info-500';
}